import React, { useEffect, useState } from 'react'

//Material UI
import { Tabs, Tab, Grid, Container, AppBar } from '@mui/material'
import './EmergencyContactSection.scss'

//Components
import EmergencyContactItem from './EmergencyContactItem'

const EmergencyContactSection = React.memo(({ emergencyContactEntity }) => {
  const [emergencyContactData, setEmergencyContactData] = useState([])
  const value = 0

  useEffect(() => {
    setEmergencyContactData(emergencyContactEntity)
  }, [emergencyContactEntity])

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <div>{children}</div>}
      </div>
    )
  }

  return (
    <div className="emergency-contact-section">
      <AppBar elevation={0} position="static" className="header">
        <Tabs
          variant="fullWidth"
          value={value}
          border={1}
          centered={true}
          className="detail-tabs-container"
          aria-label="simple tabs example"
        >
          <Tab
            className="detail-tab border-tab"
            label={<h3 className="emergency-title">Emergency contacts</h3>}
            {...a11yProps(0)}
          />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <Container maxWidth="lg" className="emergency-contacts">
          <Grid container spacing={1}>
            <Grid size={12}></Grid>
            {emergencyContactData && emergencyContactData.length > 0 && (
              <>
                {emergencyContactData.map((item, index) => (
                  <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                    <h4>{`Emergency Contact #${index + 1}`}</h4>
                    <EmergencyContactItem emergencyContactItem={item} />
                  </Grid>
                ))}
              </>
            )}
          </Grid>
        </Container>
      </TabPanel>
    </div>
  )
})

export default EmergencyContactSection
